(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('capTaskResource', {
        templateUrl: 'views/components/views/capTaskResource/capTaskResource.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'capTaskResourceService', 'layoutService', function ($stateParams, stateService, translateService, modalService, capTaskResourceService, layoutService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let capTaskResourceKeyno = $stateParams.captaskresource_keyno;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                tabletSize: layoutService.getMediaQueries().tablet,
                bgCapTaskResourceMain: {
                    selected: 'BASIS',
                    buttons: [
                        { id: 'BASIS', label: 'gb_captaskresource_main_basis', color: 'primary', onClick: () => vm.model.bgCapTaskResourceMain.selected = 'BASIS' },
                        { id: 'OTHER', label: 'gb_captaskresource_main_other', color: 'primary', onClick: () => vm.model.bgCapTaskResourceMain.selected = 'OTHER' }
                    ]
                },
                equipmentNameButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('equipmentedit', { equipment_id: vm.model.edit.equipment_id }) }
                ],
                productionOrderButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('po', { po_keyno: vm.model.edit.po_keyno }) }
                ],
                orderNumberButtons: [
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderhead', { order_internal_no: vm.model.edit.order_internal_no }) }
                ],
                edit: {},
                lockedWorking: false,
                lockedPlanned: false,
                lockedFinish: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region LOAD PROCEDURE FUNCTION CALL

            async function loadEdit() {
                vm.model.edit = (await capTaskResourceService.getEdit({ captaskresource_keyno: capTaskResourceKeyno }))[0];
            }

            // #endregion LOAD PROCEDURE FUNCTION CALL

            // #region SAVE PROCEDURE FUNCTION CALL

            function workingNewStatus() {
                vm.model.lockedWorking = true;
                
                capTaskResourceService.newStatus({
                    captaskresource_keyno: vm.model.edit.captaskresource_keyno,
                    new_postatus_no: '200'
                }).then((response) => {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: (dialogItself) => {
                                    dialogItself.close();
                                    vm.model.lockedWorking = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedWorking = false;
                        loadEdit();
                    }
                });
            }

            function plannedNewStatus() {
                vm.model.lockedPlanned = true;

                capTaskResourceService.newStatus({
                    captaskresource_keyno: vm.model.edit.captaskresource_keyno,
                    new_postatus_no: '100'
                }).then((response) => {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: (dialogItself) => {
                                    dialogItself.close();
                                    vm.model.lockedPlanned = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedPlanned = false;
                        loadEdit();
                    }
                });
            }

            function finishNewStatus() {
                vm.model.lockedFinish = true;

                capTaskResourceService.newStatus({
                    captaskresource_keyno: vm.model.edit.captaskresource_keyno,
                    new_postatus_no: '300'
                }).then((response) => {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: (dialogItself) => {
                                    dialogItself.close();
                                    vm.model.lockedFinish = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedFinish = false;
                        loadEdit();
                    }
                });
            }

		    // #endregion SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON RADIO FUNCTION

            vm.selectBgCapTaskResourceMain = function (value) {
                vm.model.bgCapTaskResourceMain.selected = value;
            }

		    // #endregion BUTTON RADIO FUNCTION

            // #region ACTIVATE MULTI BUTTON FUNCTIONS

            vm.activateFunc = function (action) {
                switch (action) {
                    case 'working':
                        workingNewStatus();
                        break;
                    case 'planned':
                        plannedNewStatus();
                        break;
                    case 'finish':
                        finishNewStatus();
                        break;
                    default:
                        break;
                }
            };

		    // #endregion ACTIVATE MULTI BUTTON FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                translate();
                loadEdit();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
